import { useEffect, useState } from 'react';

import { useLangGraphClient } from '../api';
import { useGraphServerInfo } from '../api/useGraphSwr';
import { isHostedUrl } from '../utils';

export const useLangSmithTracingEnabled = () => {
  const [_, apiUrl] = useLangGraphClient();

  const apiInfo = useGraphServerInfo();
  const missingLangSmithKey = apiInfo.data?.flags?.langsmith === false;

  const [showLangSmithKeyWarning, setShowLangSmithKeyWarning] = useState(
    !isHostedUrl(apiUrl) && missingLangSmithKey
  );
  useEffect(() => {
    setShowLangSmithKeyWarning(!isHostedUrl(apiUrl) && missingLangSmithKey);
  }, [apiUrl, missingLangSmithKey]);

  return {
    langSmithTracingEnabled: !missingLangSmithKey,
    showLangSmithKeyWarning,
  };
};
